import { colors } from "@material-ui/core";
import Preloader from "components/Preloader/Preloader";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import styled from "styled-components/macro";
import {
  selectElementsLoading,
  selectOrderElementsByObjectType,
} from "../ordersAdminSlice";
import AdminCartElement from "./AdminCartElement";

interface OrderProductsProps {
  noProductsMessage: string;
  objectTypes: string[];
  removeItemHandler?: any;
}

const OrderProducts: React.FC<OrderProductsProps> = ({
  noProductsMessage,
  objectTypes,
  removeItemHandler,
}) => {
  const orderElements = useSelector((state: RootState) =>
    selectOrderElementsByObjectType(state, objectTypes)
  );
  const isLoading = useSelector(selectElementsLoading);

  return (
    <OrderPreview>
      <Title>Добавени продукти</Title>
      {isLoading ? (
        <Preloader />
      ) : orderElements.length > 0 ? (
        <Items>
          {orderElements.map((item, idx) => {
            return (
              <AdminCartElement
                key={idx}
                item={item}
                removeItemHandler={removeItemHandler}
              />
            );
          })}
        </Items>
      ) : (
        <NoProductsInOrder>{noProductsMessage}</NoProductsInOrder>
      )}
    </OrderPreview>
  );
};

export const OrderPreview = styled.div`
  margin: 30px 0;
  width: 100%;
`;

export const Title = styled.h3`
  color: black;
`;

export const Items = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 20px;
`;

export const NoProductsInOrder = styled.p`
  width: 100%;
  color: black;
  background-color: ${colors.grey[400]};
  padding: 20px;
  text-align: center;
  font-weight: bold;
`;

export default memo(OrderProducts);
